import axios from "axios"

export default function getBonanzaPoint({ id }) {
    return new Promise((resolve, reject) => {
        axios.get(`/campaign/api/admin/campaigns-setting/${id}`)
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}